import { Navbar } from "../../../components";
import { useState } from "react";
import Container from "../../../components/shared/Container";
import MyCoursesReviews from "./MyCoursesReviews";
import MyInstructorsReviews from "./MyInstructorsReviews";
import MyRoomsReviews from "./MyRoomsReviews";

enum ReviewsTabs {
  COURSES = "Courses",
  INSTRUCTORS = "Instructors",
  CLASSROOMS = "Classrooms",
}
export default function MyReviews() {
  const [activeTab, setActiveTab] = useState<ReviewsTabs>(ReviewsTabs.COURSES);
  return (
    <div>
      <Navbar />
      <Container>
        <div className="w-full flex flex-col justify-start items-start space-y-[24px] px-[20px] md:px-[102px] my-[30px]">
          {/* my reviews page header text */}
          <span className="font-inter font-bold text-[32px] leading-[38px] tracking-tight text-[#1B0209]">
            My Reviews
          </span>
          {/* my reviews page tabs */}
          <div className="flex border-b-[1px] border-[#FFC9D9] max-w-[342px]">
            {Object.values(ReviewsTabs).map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className="h-[37px] px-[18px] pb-[14px] flex justify-center items-center relative"
              >
                <span
                  className={`text-[#1B0209] font-inter font-normal text-[16px] leading-[25px] ${
                    activeTab === tab ? "" : "opacity-80"
                  }`}
                >
                  {tab}
                </span>
                <div
                  className={`absolute left-1/2 transform -translate-x-1/2 bottom-0 w-full transition-all ${
                    activeTab === tab ? "border-[#E83C70] border-[2px]" : ""
                  }`}
                />
              </button>
            ))}
          </div>
          {/* my reviews based on the selected tab */}
          {activeTab === ReviewsTabs.COURSES && <MyCoursesReviews />}
          {activeTab === ReviewsTabs.INSTRUCTORS && <MyInstructorsReviews />}
          {activeTab === ReviewsTabs.CLASSROOMS && <MyRoomsReviews />}
        </div>
      </Container>
    </div>
  );
}
